import {
  cellStyle,
  DateInput,
  DespatchAdviceSubType,
  GenericDateField,
  GenericSimpleField,
  Metadata,
  MultiSelectInput,
  SubTypeLabels,
  widthPresets,
} from '@dx-ui/dx-common';
import { TextInput } from 'react-admin';
import { DocumentSubTypeField } from './CommonFields';

export const DespatchAdviceIdField = (props) => (
  <GenericSimpleField {...props} />
);

export const DespatchAdviceDateField = (props) => (
  <GenericDateField {...props} />
);

export const createColumnsDespatchAdvice = () => [
  {
    id: Metadata.despatchAdviceId,
    label: 'dxMessages.headers.despatchAdviceId',
    sortable: false, // Alfresco doesn't allow sorting on d:text
    hiddenByDefault: true,
    width: widthPresets.small,
    cellStyle: cellStyle,
    renderCell: (props) => <DespatchAdviceIdField {...props} />,
  },
  {
    id: Metadata.despatchAdviceDate,
    label: 'dxMessages.headers.despatchAdviceDate',
    sortable: true,
    hiddenByDefault: true,
    width: widthPresets.medium,
    cellStyle: cellStyle,
    renderCell: (props) => <DespatchAdviceDateField {...props} />,
  },
];

export const createSpecificColumnsDesadv = () => [
  {
    id: Metadata.documentSubTypeCode,
    label: 'dxMessages.headers.documentSubTypeCode',
    sortable: false,
    hiddenByDefault: true,
    width: widthPresets.large,
    cellStyle: cellStyle,
    renderCell: (props) => <DocumentSubTypeField {...props} />,
  },
];

export const createDesadvFilters = () => [
  {
    id: Metadata.documentSubTypeCode,
    filter: (props) => (
      <MultiSelectInput
        label='dxMessages.headers.documentSubTypeCode'
        source={Metadata.documentSubTypeCode}
        width={widthPresets.large}
        sortLabels={true}
        {...props}
        options={[
          {
            id: DespatchAdviceSubType.LogisticOnly,
            label: SubTypeLabels[DespatchAdviceSubType.LogisticOnly],
          },
        ]}
      />
    ),
  },
];

export const createDespatchAdviceFilters = () => [
  {
    id: Metadata.despatchAdviceId,
    filter: (props) => (
      <TextInput
        source={Metadata.despatchAdviceId}
        label='dxMessages.headers.despatchAdviceId'
        resettable
        {...props}
      />
    ),
  },
  {
    id: Metadata.despatchAdviceDate,
    filter: (props) => (
      <DateInput
        source={Metadata.despatchAdviceDate}
        label='dxMessages.headers.despatchAdviceDate'
        {...props}
      />
    ),
  },
];
